<template>
  <div class="contact-blk">
    <div class="top-mail-blk">
      <img src="/assets/img/email.svg" alt />
      <p>
        email us
        <a href="mailto:service@phoxwater.com">service@phoxwater.com</a>
      </p>
    </div>
    <a href="https://m.me/phoxwater/" target="_blank">
    <img class="message-blk" src="/assets/img/message.svg" alt />
    </a>
    <div class="contact-social">
      <h4>Follow us</h4>
      <a href="https://www.instagram.com/phoxwater/" target="_blank">
        <img src="/assets/img/insta.svg" alt />
      </a>
      <a href="https://twitter.com/PhoxWater" target="_blank">
        <img src="/assets/img/white twitter.svg" alt />
      </a>
      <p>@phoxwater</p>
    </div>
  </div>
</template>
<script>
export default {
  head: function() {
    return {
      title: {
        inner: 'Contact Us'
      }
    }
  }
}
</script>